import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { black, text } from "@/theme/colors";
import { IconCheckCircle } from "@/assets/icons/IconCheckCircle";
import { EMPTY_STR } from "@/constants/string";
import { IconBox } from "@/components/elements/IconBox";

type TJobFeatureDetailProps = {
  defaultValues?: Partial<TJobForm>;
};

export const JobFeatureDetail: FC<TJobFeatureDetailProps> = ({ defaultValues }) => {
  const OnboardingSupportDetail = () => {
    if (defaultValues?.onboardingSupport && defaultValues?.onboardingSupport.length > 0) {
      const render = defaultValues?.onboardingSupport.map((item, index) => {
        if (item.checked) {
          return (
            <Stack key={index} direction="row" justifyContent="flex-start" alignItems="center" position="relative">
              <IconBox sx={{ position: "absolute", top: "-2px", left:"-24px"}}>
                <IconCheckCircle />
              </IconBox>
              <Typography
                variant="body14"
                color={text.primary}
                sx={{
                  fontFamily: "inherit",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                }}
              >
                {item.label}
              </Typography>
            </Stack>
          );
        }
      });
      return <>{render}</>
    }
    return <Typography>{EMPTY_STR.TEXT}</Typography>;
  };
  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="特性" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JobInfoItem label="特性メモ" value={defaultValues?.memo} isShowDivider={false} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="求人特性メモ" value={defaultValues?.jobMemo} isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="在籍外国人" value={defaultValues?.foreignEmployees} isShowDivider={false} />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="cap12Light" color={black[70]}>受け入れ体制・サポート</Typography>
            <OnboardingSupportDetail />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
